import { render, staticRenderFns } from "./UploadOne.vue?vue&type=template&id=c2aa161a&scoped=true"
import script from "./UploadOne.vue?vue&type=script&lang=js"
export * from "./UploadOne.vue?vue&type=script&lang=js"
import style0 from "./UploadOne.vue?vue&type=style&index=0&id=c2aa161a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aa161a",
  null
  
)

export default component.exports